import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const TermsPage = () => (
  <div className="min-h-screen bg-white overflow-x-hidden">
    <section className="py-16 md:py-20 bg-gradient-to-r from-blue-900 to-blue-800 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms of Service</h1>
        <p className="text-blue-200">Last updated: March 2026</p>
      </div>
    </section>

    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 text-gray-700 space-y-8">
      <motion.section initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
        <p className="leading-relaxed">
          By accessing and using the Arabian Link Doors website, you agree to these Terms of Service.
          If you do not agree, please do not use this website.
        </p>
      </motion.section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Use of Website</h2>
        <p className="leading-relaxed mb-3">
          This website provides information about automatic door products, services, and industry updates.
          Content is for general information only and does not constitute a binding offer until confirmed in writing.
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>You agree not to misuse the website or attempt unauthorized access to our systems.</li>
          <li>You must provide accurate information when submitting contact or newsletter forms.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Quotes & Services</h2>
        <p className="leading-relaxed">
          Project specifications, pricing, and timelines are subject to site survey, technical assessment,
          and formal quotation. Images and descriptions on this site are representative and may vary by project requirements.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Intellectual Property</h2>
        <p className="leading-relaxed">
          All content on this website — including text, logos, images, and design — is owned by Arabian Link Doors
          or used with permission. You may not copy, reproduce, or distribute content without prior written consent.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Limitation of Liability</h2>
        <p className="leading-relaxed">
          To the fullest extent permitted by law, Arabian Link Doors shall not be liable for any indirect,
          incidental, or consequential damages arising from use of this website. We do not guarantee uninterrupted
          or error-free access to the site.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Industry Updates</h2>
        <p className="leading-relaxed">
          Industry updates and news articles on this website are provided for informational purposes.
          Older updates may be removed periodically. We are not responsible for decisions made solely based on website content.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Governing Law</h2>
        <p className="leading-relaxed">
          These terms are governed by the laws of the United Arab Emirates. Any disputes shall be subject to the
          competent courts of the UAE.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Contact</h2>
        <p className="leading-relaxed">
          Arabian Link Doors — Sharjah, UAE<br />
          Email: arabianlinkdoors@gmail.com<br />
          Phone: +971 50 494 6149
        </p>
        <p className="mt-6">
          <Link to="/privacy" className="text-blue-600 hover:underline mr-4">Privacy Policy</Link>
          <Link to="/" className="text-blue-600 hover:underline">← Back to Home</Link>
        </p>
      </section>
    </div>
  </div>
);

export default TermsPage;
